
export const WebProVpn = {
    webWin: 'https://store.bittorrent.com/849/purl-btwebprovpnwebwin',
    webMac: 'https://store.bittorrent.com/849/purl-btwebprovpnwebmac',

    clientWin: 'https://store.bittorrent.com/849/purl-btwebprovpnclientwin',
    clientMac: 'https://store.bittorrent.com/849/purl-btwebprovpnclientmac',
}
export const WebPro = {
    webWin: 'https://store.bittorrent.com/849/purl-btwebprowebwin',
    webMac: 'https://store.bittorrent.com/849/purl-btwebprowebmac',

    clientWin: 'https://store.bittorrent.com/849/purl-btwebproclientwin',
    clientMac: 'https://store.bittorrent.com/849/purl-btwebproclientmac',
}
export const WebAf = {
    webWin: 'https://store.bittorrent.com/849/purl-btwafwebwin',
    webMac: 'https://store.bittorrent.com/849/purl-btwafwebmac',

    clientWin: 'https://store.bittorrent.com/849/purl-btwafclientwin',
    clientMac: 'https://store.bittorrent.com/849/purl-btwafclientmac',
}

